import { render, staticRenderFns } from "./EmploymentElement.vue?vue&type=template&id=30cab45c&scoped=true&"
import script from "./EmploymentElement.vue?vue&type=script&lang=ts&"
export * from "./EmploymentElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cab45c",
  null
  
)

component.options.__file = "EmploymentElement.vue"
export default component.exports